var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-col',{staticClass:"align-self-center"},[_c('v-row',{staticClass:"justify-center text-center"},[_c('v-progress-circular',{attrs:{"size":70,"color":"#055289","indeterminate":""}})],1),(_vm.displayMessage)?_c('v-row',{staticClass:"caption justify-center pt-3"},[_c('span',[_vm._v(" "+_vm._s(_vm.displayMessage)+" ")])]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }